import { render, staticRenderFns } from "./TranslationEditView.vue?vue&type=template&id=b7acf2fc&"
import script from "./TranslationEditView.vue?vue&type=script&lang=js&"
export * from "./TranslationEditView.vue?vue&type=script&lang=js&"
import style0 from "./TranslationEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports